import { Card } from "@/src/components/cards";
import { closeDrawer, openDrawer } from "@/src/components/dialogs";
import { IconTab } from "@/src/components/iconTab";
import { MultiPicker, MultiPickerList } from "@/src/components/multiPicker";
import {
  openSinglePickerList,
  SinglePicker,
  SinglePickerList,
} from "@/src/components/singlePicker";
import { ExamStep, ExamStepsGroup, Reference } from "@/src/data/allTypes";
import { USER } from "@/src/data/globalVariables";
import apiFetch from "@/src/utils/apiFetch";
import { getUserId, uid } from "@/src/utils/utils";
import { useState } from "react";

function ExamStepsAndGroupsList({
  current,
  onGroupSelect,
  onChange,
}: {
  current: Reference[];
  onGroupSelect: (newValue: ExamStepsGroup) => void;
  onChange: (newValue: Reference[]) => void;
}) {
  const [currentType, setCurrentType] = useState<"group" | "step">("step");
  const [value, setValue] = useState<Reference[]>(current);

  return (
    <div className="c1 gap20">
      {/* <ExamStepTypeTabs
        current={currentType}
        onChange={(newType) => {
          setCurrentType(newType);
        }}
      /> */}
      {currentType === "group" && (
        <SinglePickerList
          queryKey={["singlePickerExamStepsGroups"]}

          loadItems={async (limit, offset, searchKey) => {
            return await apiFetch("examStepsGroups", "loadMany", {
              searchKey,
            })!;
          }}
          onAddClick={async () => {}}
          getChecboxCardContent={(item) => {
            return (
              <div>
                <div className="bold">{item.name}</div>
              </div>
            );
          }}
          current={null}
          onChange={(newValue) => {
            onGroupSelect(newValue!);
          }}
        />
      )}
      {currentType === "step" && (
        <MultiPickerList
          queryKey={["multiPickerExamSteps"]}
          loadItems={async (limit, offset, searchKey, viewType, ids) => {
            return USER.get()?.speciality?.frequentReferences?.filter(
              (item) => item?.category == "examStep"
            ) || [];
          }}
          onAddClick={async () => {}}
          getChecboxCardContent={(item) => {
            return (
              <div>
                <div className="bold">{item.name}</div>
              </div>
            );
          }}
          current={value || []}
          onChange={(newValue) => {
            setValue(newValue.filter((item) => item != undefined));
            onChange(newValue.filter((item) => item != undefined));
          }}
        ></MultiPickerList>
      )}
    </div>
  );
}

export async function openExamStepsPicker({
  current,
  onConfirm,
}: {
  current: Reference[];
  onConfirm: (newValue: Reference[]) => void;
}) {
  await openDrawer({
    id: "examStepsPicker",
    title: "Ajouter des étapes d'examen",
    content: (
      <ExamStepsAndGroupsList
        current={current}
        onGroupSelect={(newGroup) => {
          closeDrawer("examStepsPicker");
          let steps = (newGroup.steps || []).filter(
            (item) => item != undefined
          );
          onConfirm(steps);
        }}
        onChange={(newValue) => {
          current = newValue;
        }}
      />
    ),
    onConfirm: async () => {
      await onConfirm(current);
    },
  });
}

export default function ExamStepTypeTabs({
  current,
  onChange,
}: {
  current: "group" | "step";
  onChange: (newUnit: "group" | "step") => void;
}) {
  let [activeTabId, setActiveTabId] = useState(current);

  return (
    <div className="grid gap10 mc3">
      <IconTab
        key={`item-group`}
        color="blue"
        activeTabId={activeTabId}
        id={"group"}
        name={"Groupes"}
        onChange={(newId) => {
          setActiveTabId("group");
          onChange("group");
        }}
      ></IconTab>
      <IconTab
        key={`item-step`}
        color="blue"
        activeTabId={activeTabId}
        id={"step"}
        name={"Etapes"}
        onChange={(newId) => {
          setActiveTabId("step");
          onChange("step");
        }}
      ></IconTab>
    </div>
  );
}
